import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import RfqMyQuotesReducer from "@insite/client-framework/Store/Pages/RfqMyQuotes/RfqMyQuotesReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CustomCheckoutShippingReducer from "@MasterBluePrint/Store/Components/CustomCheckoutShipping/CustomCheckoutShippingReducer";
import CustomCheckoutShippingState from "@MasterBluePrint/Store/Components/CustomCheckoutShipping/CustomCheckoutShippingState";
import CustomCountryReducer from "@MasterBluePrint/Store/Components/CustomCountry/CustomCountryReducer";
import CustomCountryState from "@MasterBluePrint/Store/Components/CustomCountry/CustomCountryState";
import ResetMultipleSaleQuantityReducer from "@MasterBluePrint/Store/Components/ProductDetails/ResetMultipleSaleQuantityReducer";
import ResetMultipleSaleQuantityState from "@MasterBluePrint/Store/Components/ProductDetails/ResetMultipleSaleQuantityState";
import RfqMyQuotesState from "@MasterBluePrint/Store/Pages/RfqMyQuotes/RfqMyQuotesState";
import CustomProductInfoListStatusState from "@MasterBluePrint/Store/Components/CustomProductInfoList/CustomProductInfoListStatusState";
import CustomProductInfoListReducer from "@MasterBluePrint/Store/Components/CustomProductInfoList/CustomProductInfoListReducer";

export type CustomApplicationState={
    customCheckoutShippingState: CustomCheckoutShippingState,
    rfqMyQuotes: RfqMyQuotesState,
    resetMultipleSaleQuantityState: ResetMultipleSaleQuantityState,
    customCountryState: CustomCountryState,
    customProductInfoListStatusState: CustomProductInfoListStatusState
} & ApplicationState;

(reducers as any).customCheckoutShippingState = CustomCheckoutShippingReducer;
(reducers as any).rfqMyQuotes = RfqMyQuotesReducer;
(reducers as any).resetMultipleSaleQuantityState = ResetMultipleSaleQuantityReducer;
(reducers as any).customCountryState = CustomCountryReducer;
(reducers as any).customProductInfoListStatusState = CustomProductInfoListReducer;

type CustomApplicationReducers = typeof reducers;

export type CustomApplicationActions = AnyAction | Parameters<CustomApplicationReducers[keyof CustomApplicationReducers]>[1];
